import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, OperatorFunction } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/internal/operators';
import { apiURL, customerEndpoint } from '../../constants';
import { GenericService } from '../../service/GenericService.service';
import { SpinnerService } from '../../service/spinner.service';
import { Customer } from '../model/customer.model';
import { Response } from '../../service/response.model';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';

const mapResponseToCustomer: OperatorFunction<Response<Customer>, Customer> = map<Response<Customer>, Customer>(data => data && data.successful ? data.output : null);

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends GenericService<Customer> {


  /**
   * 
   * @param http 
   * @param spinnerService 
   * @param flashMessagesService 
   */
  constructor(
    protected http: HttpClient,
    private spinnerService: SpinnerService,
    protected flashMessagesService: FlashMessagesService
  ) {
    super(http, apiURL + customerEndpoint, flashMessagesService);
  }

  /**
   * Returns the customer or null.
   * @param customerNum
   */
  getCustomer(customerNum: number): Observable<Customer> {
    this.spinnerService.startSpinner();
    return this.getSingle(customerNum)
      .pipe<Customer>(
        mapResponseToCustomer,
        catchError(this.handleErrors('getCustomer', null)),
        finalize(() => this.spinnerService.stopSpinner())
      );
  }

}
